import { useEffect, useMemo } from "react"

import { PlusCircleIcon } from "lucide-react"
import { AccordionFolder } from 'twyne-new.ui'

import { useEditing, useThemeTypes } from "@/modules/cms/views/post/components/builder/context"

import AddButton from "./AddButton"
import Type from "./Type"

export default function Types() {
  const types = useThemeTypes()
  const { value: editing, setValue: setEditing } = useEditing()

  useEffect(() => {
    const [{ templates }] = types?.list ?? []

    if (templates?.length > 0) setEditing(templates[0])
  }, [types, setEditing])

  const isActive = value => editing?.name === value

  const defaultValue = useMemo(() => types.list.map(item => item.name), [types])

  return <>
    <div className='flex justify-end'>
      <AddButton variant='ghost' color='neutral' size='sm'>
        <PlusCircleIcon size={16} />
      </AddButton>
    </div>
    <AccordionFolder type='multiple' defaultValue={defaultValue}>
      {types.list.map((item, idx) => <Type
        key={`${idx}`}
        idx={idx}
        data={item}
        isActive={isActive}
        onSelect={setEditing}
      />)}
    </AccordionFolder>
  </>
}
